import React from "react"
import { ListItemAvatar, ListItemText } from "@material-ui/core"
import { Avatar, CheckboxPickerListItem, Icon } from ".."

const GroupPickerListItem = ({ iconName, ...props }) => (
  <CheckboxPickerListItem {...props}>
    <ListItemAvatar>
      <Avatar icon={<Icon name={iconName || "group"} />} />
    </ListItemAvatar>
    <ListItemText>{props.item.name}</ListItemText>
  </CheckboxPickerListItem>
)

export default GroupPickerListItem
